
import Vue from "vue";
import LabsService from "../../services/LabsService";
import CreateEditFeatureModal from "./CreateEditFeatureModal.vue";
import HiddenFeatureControlModal from "./HiddenFeatureControlModal.vue";
import draggable from "vuedraggable";

export default Vue.extend({
  components: { CreateEditFeatureModal, HiddenFeatureControlModal, draggable },
  data() {
    return {
      loading: false,
      enableField: true,
      features: [] as any,
      modalOpen: false,
      editFeature: null,
      deleting: "",
      featureType: "location" as "location" | "company",
      searchQuery: "",
      featureStats: null as any,
      hiddenFeature: null as any,
      hiddenFeatureModalOpen: false,
      featureStatTooltips: {
        interactedCompanies:
          "Count of companies where this feature flag was toggled at least once at any point. This includes companies that may be currently enabled or currently disabled.",
        interactedLocations:
          "Count of locations where this feature flag was toggled at least once at any point. This includes locations that may be currently enabled or currently disabled.",
        enabledCompanies:
          "Count of companies where this feature flag is currently enabled.",
        enabledLocations:
          "Count of individual locations where this feature flag is currently enabled.",
        totalEnabledLocations:
          "Count of individual enabled locations plus the location count of companies where this feature is enabled company-wide.",
      },
    };
  },

  computed: {
    filteredFeatures() {
      const features: any[] = this.$data.features;
      const searchQuery: string = this.$data.searchQuery;

      if (!searchQuery.trim()) {
        return features;
      }

      const query = searchQuery.toLowerCase().trim();
      return features.filter((feature: any) => {
        return (
          feature.name.toLowerCase().includes(query) ||
          feature.details.heading.toLowerCase().includes(query) ||
          feature.details.body.toLowerCase().includes(query) ||
          feature.key?.toLowerCase().includes(query)
        );
      });
    },
  },

  methods: {
    toggleField() {},
    isFeatureLive(feature: any) {
      return feature?.liveAt ? new Date(feature.liveAt) < new Date() : false;
    },
    created(feat: any) {
      this.features.unshift(feat);
    },
    updated(feat: any) {
      const index = this.features.findIndex((f: any) => f._id === feat._id);
      if (index === -1) {
        this.features.unshift(feat);
        return;
      }
      const currentFeature = this.features[index];
      this.$set(this.features, index, {
        ...currentFeature,
        ...feat,
        details: {
          ...(currentFeature && currentFeature.details),
          ...(feat && feat.details),
        },
      });
    },
    edit(feat: any) {
      this.editFeature = feat;
      this.modalOpen = true;
    },
    openHiddenFeatureControl(feat: any) {
      this.hiddenFeature = feat;
      this.hiddenFeatureModalOpen = true;
    },
    closeHiddenFeatureControl() {
      this.hiddenFeatureModalOpen = false;
      this.hiddenFeature = null;
    },
    close() {
      this.modalOpen = false;
      this.editFeature = null;
    },
    async deleteFeat(feat: any) {
      this.deleting = feat._id;
      await LabsService.deleteLabsFeature(feat._id);
      this.deleting = "";
      this.features.splice(
        this.features.findIndex((f: any) => feat._id === f._id),
        1
      );
    },
    async dragged(e: any) {
      this.$nextTick().then(async () => {
        const before = this.features[e.moved.newIndex - 1];
        const after = this.features[e.moved.newIndex + 1];
        const position = before ? before.position - 1 : after.position + 1;
        await LabsService.updateLabsFeature(
          this.features[e.moved.newIndex]._id,
          { position }
        );
      });
    },
    async showStats(feature: any) {
      this.featureStats = { featureName: feature.name };
      await this.$nextTick();
      const modal: any = this.$refs.featureStatsModal;
      modal.show();
      const response = await LabsService.getFeatureStats(
        feature.key,
        feature.type
      );
      this.featureStats = { ...response.data, featureName: feature.name };
    },
    getSafeExternalUrl(value: any) {
      if (typeof value !== "string") return "";
      const normalizedValue = value.trim();
      if (!normalizedValue) return "";
      try {
        const parsedUrl = new URL(normalizedValue);
        return parsedUrl.protocol === "http:" || parsedUrl.protocol === "https:"
          ? parsedUrl.toString()
          : "";
      } catch {
        return "";
      }
    },
    getFeatureMediaUrls(feature: any) {
      if (!feature || !Array.isArray(feature.media)) return [];
      return feature.media
        .map((mediaUrl: any) => this.getSafeExternalUrl(mediaUrl))
        .filter((mediaUrl: string) => Boolean(mediaUrl));
    },
    hasFeatureResources(feature: any) {
      return Boolean(
        this.getSafeExternalUrl(feature && feature.changelog) ||
          this.getSafeExternalUrl(feature && feature.supportDoc) ||
          this.getFeatureMediaUrls(feature).length
      );
    },
  },
  watch: {
    featureType: {
      async handler(type) {
        try {
          this.loading = true;
          this.features = (await LabsService.getLabsFeatures(type)).data;
        } catch (error) {
        } finally {
          this.loading = false;
        }
      },
      immediate: true,
    },
  },
  filters: {
    date(v: string) {
      return v ? new Date(v).toDateString() : "-";
    },
  },
});
